import axios from 'axios';

const apiGetCompany = 'api/apr'

export default class APRService {
  public getCompany(maticniBroj: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
      .get(`${apiGetCompany}/${maticniBroj}`)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
    });  
  }
}
